var _path, _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWrong(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.8889 0C39.2196 0 29.7674 2.86728 21.7277 8.23926C13.688 13.6112 7.42175 21.2466 3.72147 30.1799C0.0211825 39.1132 -0.94698 48.9431 0.939408 58.4266C2.8258 67.9102 7.48201 76.6213 14.3192 83.4586C21.1565 90.2958 29.8677 94.952 39.3512 96.8384C48.8347 98.7248 58.6646 97.7566 67.5979 94.0563C76.5312 90.3561 84.1666 84.0898 89.5386 76.0501C94.9105 68.0104 97.7778 58.5582 97.7778 48.8889C97.7778 35.9228 92.627 23.4877 83.4586 14.3192C74.2901 5.15078 61.8551 0 48.8889 0Z",
    fill: "#FF2F2F"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 23,
    width: 51,
    height: 51,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1_9",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1_9",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAABmJLR0QA/wD/AP+gvaeTAAACgUlEQVR4nO2czU4UQRhFb7sA34ywMGqizzQ8hu6NEk1AX0h8BDQxl8V0iQk9zXRP1fdTfU8yYUXV+U6GGjIDBQghhBBCCCGEEEKIJ5A8J3lF8m58XJE89/Y6lhT+JM9IfuVTvpN86e33HCn8ZyTjyU6Qwv8IyTiyE6TwXyDpLztBCv8VkqFip/Dn/tX5ZoVk4YaOr+Zp/Ln/tedUXGJXiFzYWcjeVRAljY8Rrj8upvi1dP8XLYY6kgsA1xaxSZ4B+ATgVaUl/y79hjWhP6z4nkNcAPjMhsfIuPY16kUGgI8V15qG9c65/2lyZmdyPTRAzfOuUPXMzuCYfpDIbt0MFNGpCpEGi+TShAgDRnAwwXNQz71d8BjYY88QWA5uuVdILAJY7JGCliFart2qx9BqYeDf+wxfAFxWXPZ2/Fp7zbfDMPyuuKYtjZ59Ncl3XByCcWP3E7nAeLH7i1xgnNj9Ri7QP3b/kQuOsbcTueAQe3uRC4axtxu5YBBbkQsNY4eJ7Pl3HcKShs/mcM9qNwwiK7Zh5O3Gdoi8vdiOkbcTO0DkQr+xGSdyob/YjBe50E9sxo1cMImtD2cf18z54Sz15wbtsQhhsUdoLANY7hUKj8E99nTFc2DPvU2JMGgEh6ZEGjCSS1UiDhbR6SQiDxTZrbtBMjg+N0Caf/vN5DolX+O+DjNxtomd6r4O0uhHkfWPkVT3dfwA8GYYhvvWGw3D8AfAOwDfKi2Z5r6OWwCvLSIXxtjv8fg26ymkuK9Dl1ctkI1/nVkv/itkQ0QupPJfIBsqciGV/xGy/pIzpPKfkY0jOUMqf+5fzXckf46PHaNddD1Ddn8hhBBCCCGEEEIISx4AgjuniZaK5fIAAAAASUVORK5CYII="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrong);
export default __webpack_public_path__ + "static/media/wrong.6791a7383ba519b3ecfd2ae7ff65cc3b.svg";
export { ForwardRef as ReactComponent };